import { createSlice } from "@reduxjs/toolkit";
import { showPeriod } from "../actions";

const initialState = {
  period: [],
};

const periodSlice = createSlice({
  name: "period",
  initialState,
  reducers: {},
  extraReducers: {
    [showPeriod.fulfilled]: (state, action) => {
      state.period = action.payload || [];
    },
  },
});

export const responsePeriod = (state) => state.period;

export default periodSlice.reducer;
